<template>
  <div class="html-editor mb-4">
    <div class="html-editor__label">{{ label }}</div>
    <vue-editor
      :value="value || ''"
      :editor-toolbar="toolbar"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor"

export default {
  name: "HtmlEditor",
  components: { VueEditor },
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
  }),
}
</script>

<style>
.html-editor__label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 4px;
}

.html-editor .ql-toolbar.ql-snow {
  border-color: rgba(0, 0, 0, 0.38);
  border-radius: 4px 4px 0 0;
}

.html-editor .ql-container.ql-snow {
  border-color: rgba(0, 0, 0, 0.38);
  border-radius: 0 0 4px 4px;
  min-height: 180px;
}

.html-editor .ql-editor {
  min-height: 180px;
  font-size: 16px;
}

/* Quill dropdowns/tooltips sit above the Vuetify dialog overlay */
.v-dialog .ql-snow .ql-tooltip,
.v-dialog .ql-snow .ql-picker-options {
  z-index: 300;
}
</style>
